/*eslint-disable*/
import Api from '../';
import _ from 'lodash';

class UserApi {
    // GET: user/profile
    static profile() {
        return Api.axios.get('/user/profile').then(resp => {
            if (!_.isEmpty(resp)) {
                return Object.assign({}, { user: resp.data.user });
            }
        });
    }

    // GET: user/:id
    static show(id) {
        return Api.axios.get('/user/' + id).then(response => Object.assign({}, response.data.user));
    }

    // GET: user
    static list(params, cancelToken = null) {
        return Api.axios.get('/user', { params, cancelToken }).then(response => {
            response.data.data = _.map(response.data.data, item => Object.assign({}, item));
            return response.data;
        });
    }

    static exportList(params) {
        return Api.axios.get('/user/export', { params }).then(response => response.data);
    }

    // POST: user
    static create(user) {
        return Api.axios.post('/user', user).then(response => response.data.user);
    }

    //PUT: user/:id
    static update(id, user) {
        return Api.axios.put('/user/' + id, user).then(response => response.data.user);
    }

    static delete(id) {
        return Api.axios.delete('/user/' + id).then(response => response.data);
    }

    //GET: user/amounts
    static amounts() {
        return Api.axios.get('/user/amounts');
    }

    static amountsOfMessages() {
        return Api.axios.get('/user/amounts_of_messages');
    }

    static amountsOfTickets() {
        return Api.axios.get('/user/amounts_of_tickets');
    }

    static getUserAccountsInfo() {
        return Api.axios.get('/user/get_user_accounts_info').then(response => response.data);
    }

    //GET: user/token/:id
    static getUserTokenById(id) {
        return Api.axios.get('/user/token/' + id).then(response => response.data.token);
    }

    //POST: user/:id/points
    static updatePoints(id, params) {
        return Api.axios
            .post(`user/${id}/points`, { points: params.points, pointsAccess: params.pointsAccess })
            .then(response => response);
    }

    //POST: user/:id/miles
    static updateMiles(id, points) {
        return Api.axios.post(`user/${id}/miles`, { points }).then(response => response);
    }

    //POST: user/:id/miles
    static updateDetectivePoints(id, points) {
        return Api.axios.post(`user/${id}/detective-points`, { points }).then(response => response);
    }

    static countExercise(userId, exerciseId) {
        return Api.axios.post(`user/${userId}/exercise/${exerciseId}`).then(response => response.data.exerciseStat);
    }

    static countHomework(userId, homeworkId) {
        return Api.axios.post(`user/${userId}/homework/${homeworkId}`).then(response => response.data.homework);
    }

    //POST: user/:id/city
    static updateCity(id) {
        return Api.axios.post(`user/${id}/city`, id).then(response => response.data.user);
    }

    static getStars(params) {
        return Api.axios.get('user/stars', { params }).then(response => response.data);
    }

    static getDefaultImageUrl() {
        return api.env.API_ENDPOINT + '/storage/user-files/avatars/users/no-photo.svg';
    }

    static getPriceForUpdate(params) {
        return Api.axios.get(`user/price-for-update`, { params }).then(response => response.data);
    }

    static getPriceForActivate(id) {
        return Api.axios.get(`user/${id}/price-for-activate`).then(response => response.data);
    }

    static register(user) {
        return Api.axios.post('/register-admin', user).then(response => response.data.user);
    }

    static getAdminInfo() {
        return Api.axios.get('/get-admin-info').then(resp => {
            if (!_.isEmpty(resp)) {
                return Object.assign({}, { user: resp.data.user });
            }
        });
    }
}

export default UserApi;
